import { excludeBranchModalOptions } from 'modals/modal-options-factory';
import { cycleTimeExclusionReasons } from '../cycleTimeUtil';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';
import React from 'react';
import { updateExcludeBranchCycleTime } from 'common/services/branches.service';

const ActionsMenuCell = ({
  branch,
  toggleModal,
  toggleSnackBar,
  onBranchUpdate
}) => {
  const {
    cycle_time_excluded: isCycleTimeExcluded,
    cycle_time_excluded_reason: cycleTimeExclusionReason
  } = branch;

  const isBranchExcluded =
    isCycleTimeExcluded &&
    cycleTimeExclusionReason === cycleTimeExclusionReasons.USER_SELECTION;

  const excludedBranchesData = isBranchExcluded
    ? {
        menuItemKey: 'Include',
        menuItemText: 'Cancel branch exclusion'
      }
    : {
        menuItemKey: 'Exclude',
        menuItemText: `Exclude from all metrics`,
        icon: <Icon name='branch' color='shuttleGray' size='small' />
      };

  return (
    <MenuButton
      width='fit-content'
      items={[
        <MenuButtonItem
          key={excludedBranchesData.menuItemKey}
          text={excludedBranchesData.menuItemText}
          icon={excludedBranchesData.icon}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            toggleModal(
              excludeBranchModalOptions({
                branch,
                isBranchExcluded,
                close: () => toggleModal(),
                excludeBranch: async () => {
                  toggleModal(); // close modal immediately after clicking on save
                  try {
                    await updateExcludeBranchCycleTime({
                      branchId: branch.id,
                      queryParams: `is_excluded=true`
                    });
                    onBranchUpdate();
                  } catch {
                    toggleSnackBar({
                      message: (
                        <Text size='large' color='white'>
                          Failed to exclude branch
                        </Text>
                      ),
                      variant: 'error'
                    });
                    return;
                  }
                  toggleSnackBar({
                    message: (
                      <Text size='large' color='white'>
                        Branch excluded successfully from cycle time calculation
                      </Text>
                    ),
                    variant: 'success'
                  });
                },
                includeBranch: async () => {
                  toggleModal(); // close modal immediately after clicking on save
                  try {
                    await updateExcludeBranchCycleTime({
                      branchId: branch.id,
                      queryParams: `is_excluded=false`
                    });
                    onBranchUpdate();
                  } catch {
                    toggleSnackBar({
                      message: (
                        <Text size='large' color='white'>
                          Failed to include branch
                        </Text>
                      ),
                      variant: 'error'
                    });
                    return;
                  }
                  toggleSnackBar({
                    message: (
                      <Text size='large' color='white'>
                        Branch included successfully to cycle time calculation
                      </Text>
                    ),
                    variant: 'success'
                  });
                }
              })
            );
          }}
        />
      ]}
    />
  );
};

export default ActionsMenuCell;
